/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect } from "react";
import QuestionComponent from "./questionComponent";
import { FormikProps, useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { saveClassicationType } from "../../../redux/Action/Action";
import { SET_CLASSIFICATION_QUESTIONNAIRE } from "../../../redux/Action/actionTypes";
import { RootState } from "../../../redux/Reducer";

type setClassificationHandlerProps = {
  setRefInstance: (instance: FormikProps<any> | null) => void;
  setIsSubmitDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  classificationTypeIdHandler: (typeName: string) => void
};

const questionArray = [
  "At the heart of the negotiation, facts and numbers were much more relevant for my sales rep, than the level of the relationship.",
  "My sales rep felt pressurized to find a viable solution.",
  "It was important to my sales rep to concentrate on what we have (personally) in common.",
  "My sales rep was able to improvise in any situation where he/she didn't know all the details.",
  "I had the feeling that my sales rep analyzed my weaknesses in detail (e.g. he/she knew my weak points and used them during the negotiation)",
  "When there was a disagreement, my sales rep remained silent and waited for me to give in.",
  "My sales rep made his / her points in a quiet and moderate way.",
  "My sales rep knew how to talk a lot without really giving any important information.",
  "My sales rep discussed every detail.",
  "My sales rep revealed his / her negotiation margins bit by bit.",
  "My sales rep adapted his / her behavior to my behavior.",
  "Using my weaknesses was crucial for the success of his / her negotiation.",
  "My sales rep was very much open for novel types of agreement to guarantee his / her negotiation success.",
  "From my sales rep's perspective, it was crucial for his/her success to identify my characteristics (e.g. getting to know my needs/motives)",
];

const SetClassificationQuestionaire = ({
  setRefInstance,
  setIsSubmitDisabled,
  classificationTypeIdHandler
}: setClassificationHandlerProps) => {
  const salesRepClassificationData = useSelector(
    (state: RootState) => state.salesRepClassification.classificationSettings
  );
  // default values for formik ref
  const LocalFields = {
    Q1: "",
    Q2: "",
    Q3: "",
    Q4: "",
    Q5: "",
    Q6: "",
    Q7: "",
    Q8: "",
    Q9: "",
    Q10: "",
    Q11: "",
    Q12: "",
    Q13: "",
    Q14: "",
  };

  // validation method for formik ref 
  const validateField = (LocalFields: any) => {
    let errors: any = {};
    if (!LocalFields.Q1) {
      errors.Q1 = "Q1 is required";
    }
    if (!LocalFields.Q2) {
      errors.Q2 = "Q2 is required";
    }
    if (!LocalFields.Q3) {
      errors.Q3 = "Q3 is required";
    }
    if (!LocalFields.Q4) {
      errors.Q4 = "Q4 is required";
    }
    if (!LocalFields.Q5) {
      errors.Q5 = "Q5 is required";
    }
    if (!LocalFields.Q6) {
      errors.Q6 = "Q6 is required";
    }
    if (!LocalFields.Q7) {
      errors.Q7 = "Q7 is required";
    }
    if (!LocalFields.Q8) {
      errors.Q8 = "Q8 is required";
    }
    if (!LocalFields.Q9) {
      errors.Q9 = "Q9 is required";
    }
    if (!LocalFields.Q10) {
      errors.Q10 = "Q10 is required";
    }
    if (!LocalFields.Q11) {
      errors.Q11 = "Q11 is required";
    }
    if (!LocalFields.Q12) {
      errors.Q12 = "Q12 is required";
    }
    if (!LocalFields.Q13) {
      errors.Q13 = "Q13 is required";
    }
    if (!LocalFields.Q14) {
      errors.Q14 = "Q14 is required";
    }
    return errors;
  };

  const dispatch = useDispatch();

  // formik ref for questionanair page with submit handler 
  const formik = useFormik({
    initialValues: LocalFields,
    validate: validateField,
    validateOnMount: true,
    onSubmit: (data) => {
      let rationalistScore = 0;
      let performerScore = 0;
      let harmonizerScore = 0;
      let optimizerScore = 0;

      type QuestionKey = keyof typeof LocalFields;
      const keys: QuestionKey[] = Object.keys(data) as QuestionKey[];

      const scoringMap: Record<QuestionKey, Record<string, Partial<Record<string, number>>>> = {
        Q1: { disagree: { harmonizerScore: 8 } },
        Q2: { agree: { performerScore: 1 } },
        Q3: {
          disagree: { optimizerScore: 5, rationalistScore: 5 },
          agree: { performerScore: 5, harmonizerScore: 5 },
        },
        Q4: {
          disagree: { rationalistScore: 2 },
          agree: { performerScore: 2 },
        },
        Q5: { agree: { performerScore: 1 } },
        Q6: { disagree: { rationalistScore: 2 } },
        Q7: { disagree: { optimizerScore: 2 } },
        Q8: {
          disagree: { rationalistScore: 4 },
          agree: { performerScore: 4 },
        },
        Q9: {
          disagree: { harmonizerScore: 3, optimizerScore: 3 },
          neutral: { harmonizerScore: 3, optimizerScore: 3 },
          agree: { rationalistScore: 3, performerScore: 3 },
        },
        Q10: { agree: { performerScore: 2 } },
        Q11: {
          disagree: { optimizerScore: 2 },
          agree: { performerScore: 2 },
        },
        Q12: { agree: { performerScore: 1 } },
        Q13: {
          disagree: { optimizerScore: 2 },
          agree: { rationalistScore: 2 },
        },
        Q14: { disagree: { optimizerScore: 1 } },
      };

      keys.forEach((key) => {
        const answer = data[key];
        const scoreObj = scoringMap[key]?.[answer];
        if (scoreObj) {
          if (scoreObj.rationalistScore) rationalistScore += scoreObj.rationalistScore;
          if (scoreObj.performerScore) performerScore += scoreObj.performerScore;
          if (scoreObj.harmonizerScore) harmonizerScore += scoreObj.harmonizerScore;
          if (scoreObj.optimizerScore) optimizerScore += scoreObj.optimizerScore;
        }
      });

      let rationalistPercentage = (rationalistScore * 100) / 18;
      let performerPercentage = (performerScore * 100) / 21;
      let harmonizerPercentage = (harmonizerScore * 100) / 16;
      let optimizerPercentage = (optimizerScore * 100) / 15;

      let maxValue = Math.max(
        rationalistPercentage,
        performerPercentage,
        harmonizerPercentage,
        optimizerPercentage
      );
      let maxVariables = [];

      if (rationalistPercentage === maxValue) maxVariables.push("Rationalist");
      if (performerPercentage === maxValue) maxVariables.push("Performer");
      if (harmonizerPercentage === maxValue) maxVariables.push("Harmonizer");
      if (optimizerPercentage === maxValue) maxVariables.push("Optimizer");

      if (maxVariables.length === 1) {
        dispatch(saveClassicationType(maxVariables[0]));
        classificationTypeIdHandler(maxVariables[0])
      }
      dispatch({ type: SET_CLASSIFICATION_QUESTIONNAIRE, payload: data });
    },
  });

  //setting the ref to this step form
  useEffect(() => {
    setRefInstance(formik);
  }, [formik]);

  // disabling functionality for submit button
  useEffect(() => {
    if (formik) {
      if (Object.keys(formik.errors || {}).length > 0) {
        setIsSubmitDisabled(true);
      } else {
        setIsSubmitDisabled(false);
      }
    }
  }, [formik]);

  // updating the values after fetching data from get api response 
  useEffect(() => {
    formik.setValues({ ...formik.values, ...salesRepClassificationData });
  }, []);

  return (
    <div className="setClassificationStyle">
      <p className="question-title">
        To be well prepared for your negotiation, it’s important to identify
        your sales rep’s negotiation style. This will give you a better
        understanding of your sales rep and make it easier to choose the right
        strategy.
      </p>
      <p className="indicate-text-spacing">
        Please indicate whether you agree, disagree or neutral to following
        statements:
      </p>
      <div className="row">
        <div className="col-3 offset-9 scale-text-spacing">
          <p>Disgree</p>
          <p>Neutral</p>
          <p>Agree</p>
        </div>
      </div>
      <form>
        <QuestionComponent
          name="Q1"
          questionNumber={1}
          questionText={questionArray[0]}
          value={formik.values.Q1}
          formik={formik}
        />
        <QuestionComponent
          name="Q2"
          questionNumber={2}
          questionText={questionArray[1]}
          value={formik.values.Q2}
          formik={formik}
        />
        <QuestionComponent
          name="Q3"
          questionNumber={3}
          questionText={questionArray[2]}
          value={formik.values.Q3}
          formik={formik}
        />
        <QuestionComponent
          name="Q4"
          questionNumber={4}
          questionText={questionArray[3]}
          value={formik.values.Q4}
          formik={formik}
        />
        <QuestionComponent
          name="Q5"
          questionNumber={5}
          questionText={questionArray[4]}
          value={formik.values.Q5}
          formik={formik}
        />
        <QuestionComponent
          name="Q6"
          questionNumber={6}
          questionText={questionArray[5]}
          value={formik.values.Q6}
          formik={formik}
        />
        <QuestionComponent
          name="Q7"
          questionNumber={7}
          questionText={questionArray[6]}
          value={formik.values.Q7}
          formik={formik}
        />
        <QuestionComponent
          name="Q8"
          questionNumber={8}
          questionText={questionArray[7]}
          value={formik.values.Q8}
          formik={formik}
        />
        <QuestionComponent
          name="Q9"
          questionNumber={9}
          questionText={questionArray[8]}
          value={formik.values.Q9}
          formik={formik}
        />
        <QuestionComponent
          name="Q10"
          questionNumber={10}
          questionText={questionArray[9]}
          value={formik.values.Q10}
          formik={formik}
        />
        <QuestionComponent
          name="Q11"
          questionNumber={11}
          questionText={questionArray[10]}
          value={formik.values.Q11}
          formik={formik}
        />
        <QuestionComponent
          name="Q12"
          questionNumber={12}
          questionText={questionArray[11]}
          value={formik.values.Q12}
          formik={formik}
        />
        <QuestionComponent
          name="Q13"
          questionNumber={13}
          questionText={questionArray[12]}
          value={formik.values.Q13}
          formik={formik}
        />
        <QuestionComponent
          name="Q14"
          questionNumber={14}
          questionText={questionArray[13]}
          value={formik.values.Q14}
          formik={formik}
        />
      </form>
    </div>
  );
};

export default SetClassificationQuestionaire;
